import {Optional} from '../../Common/TypeHelper'
import {ContractMethod, ConvenienceStoreKey, MobileCarrierKey} from '../Props/ContractInputInfo'
import {EnrollmentReasonSelectedInfo} from '../View/Components/InputContentBlocks/EnrollmentReasonSelectContentBlock'

export interface BucketContractInputInfo {
  contractTerm: string,
  paymentMethod: Optional<ContractMethod>,
}

export interface BucketContractInputInfoCreditCard extends BucketContractInputInfo {
  paymentMethod: 'credit_card',
  tokenList: string[],
  creditCardExpireDate: Optional<string>,
  cardId: Optional<string>,
  securityCode: Optional<string>,
}

export interface BucketContractInputInfoMobileCarrier extends BucketContractInputInfo {
  paymentMethod: 'mobile_carrier',
  paymentMethodDetail: MobileCarrierKey
}

export interface BucketContractInputInfoConvenienceStore extends BucketContractInputInfo {
  paymentMethod: 'convenience_store',
  paymentMethodDetail: ConvenienceStoreKey
}

export interface BucketContractInputInfoWithoutPayment extends BucketContractInputInfo {
  paymentMethod: 'none',
}

export class MemberJoinBucketDTO {
  signupKey: string
  agreementIdCheckedList: number[]
  mailMagazineIdCheckedList: number[]
  contractInfo: BucketContractInputInfoCreditCard |
    BucketContractInputInfoConvenienceStore |
    BucketContractInputInfoWithoutPayment
  enrollmentReason: Optional<EnrollmentReasonSelectedInfo>

  constructor(
    signupKey: string,
    agreementIdCheckedList: number[],
    mailMagazineIdCheckedList: number[],
    contractInfo: BucketContractInputInfoCreditCard |
      BucketContractInputInfoConvenienceStore |
      BucketContractInputInfoWithoutPayment,
    enrollmentReason: Optional<EnrollmentReasonSelectedInfo>,
  ) {
    this.signupKey = signupKey
    this.agreementIdCheckedList = agreementIdCheckedList
    this.mailMagazineIdCheckedList = mailMagazineIdCheckedList
    this.contractInfo = contractInfo
    this.enrollmentReason = enrollmentReason
  }
}
